import { apiClient } from '../../services/api';

/**
 * Get all deadlines (attorney view)
 */
export async function getDeadlines(options = {}) {
  const params = new URLSearchParams();
  if (options.daysAhead) params.append('daysAhead', options.daysAhead);
  if (options.urgentOnly) params.append('urgentOnly', options.urgentOnly);
  if (options.applicationId) params.append('applicationId', options.applicationId);
  if (options.assignmentFilter) params.append('assignmentFilter', options.assignmentFilter);

  const queryString = params.toString();
  const url = queryString ? `/attorney/deadlines?${queryString}` : '/attorney/deadlines';

  const response = await apiClient.get(url);
  return response.data;
}

/**
 * Get a single deadline
 */
export async function getDeadline(deadlineId) {
  const response = await apiClient.get(`/attorney/deadlines/${deadlineId}`);
  return response.data;
}

/**
 * Mark a deadline as complete
 */
export async function completeDeadline(deadlineId, data = {}) {
  const response = await apiClient.post(`/attorney/deadlines/${deadlineId}/complete`, {
    notes: data.notes
  });
  return response.data;
}

/**
 * Update a deadline
 */
export async function updateDeadline(deadlineId, data) {
  const response = await apiClient.patch(`/attorney/deadlines/${deadlineId}`, {
    action: 'update',
    ...data
  });
  return response.data;
}

/**
 * Create a manual deadline
 */
export async function createDeadline(data) {
  const response = await apiClient.post('/attorney/deadlines', data);
  return response.data;
}

export default {
  getDeadlines,
  getDeadline,
  completeDeadline,
  updateDeadline,
  createDeadline
};
